import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PaymentMethods() {
  const methods = [{
    name: 'Visa',
    svg: <svg viewBox="0 0 48 16" className="h-5" data-id="element-214">
          <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="16" fill="#1A1F71" data-id="element-215">
            VISA
          </text>
        </svg>
  }, {
    name: 'Mastercard',
    svg: <svg viewBox="0 0 40 24" className="h-6" data-id="element-216">
          <circle cx="15" cy="12" r="9" fill="#EB001B" data-id="element-217" />
          <circle cx="25" cy="12" r="9" fill="#F79E1B" data-id="element-218" />
          <path d="M20 5.5a9 9 0 010 13 9 9 0 010-13z" fill="#FF5F00" data-id="element-219" />
        </svg>
  }, {
    name: 'American Express',
    svg: <svg viewBox="0 0 48 16" className="h-5" data-id="element-220">
          <rect width="48" height="16" rx="2" fill="#006FCF" data-id="element-221" />
          <text x="6" y="11" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="6" fill="#fff" data-id="element-222">
            AMERICAN
          </text>
          <text x="8" y="14" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="4" fill="#fff" data-id="element-223">
            EXPRESS
          </text>
        </svg>
  }, {
    name: 'PayPal',
    svg: <svg viewBox="0 0 60 16" className="h-5" data-id="element-224">
          <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="14" fill="#003087" data-id="element-225">
            Pay
          </text>
          <text x="22" y="13" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="14" fill="#009CDE" data-id="element-226">
            Pal
          </text>
        </svg>
  }, {
    name: 'Stripe',
    svg: <svg viewBox="0 0 50 16" className="h-5" data-id="element-227">
          <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="14" fill="#635BFF" data-id="element-228">
            stripe
          </text>
        </svg>
  }, {
    name: 'Apple Pay',
    svg: <svg viewBox="0 0 60 16" className="h-5" data-id="element-229">
          <text x="0" y="13" fontFamily="-apple-system, Arial" fontWeight="700" fontSize="13" fill="#000" data-id="element-230">
            {' '}
            Pay
          </text>
        </svg>
  }, {
    name: 'Google Pay',
    svg: <svg viewBox="0 0 70 16" className="h-5" data-id="element-231">
          <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#4285F4" data-id="element-232">
            G
          </text>
          <text x="9" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#EA4335" data-id="element-233">
            o
          </text>
          <text x="17" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#FBBC04" data-id="element-234">
            o
          </text>
          <text x="25" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#34A853" data-id="element-235">
            g
          </text>
          <text x="33" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#4285F4" data-id="element-236">
            l
          </text>
          <text x="37" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#EA4335" data-id="element-237">
            e
          </text>
          <text x="47" y="13" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="13" fill="#333" data-id="element-238">
            {' '}
            Pay
          </text>
        </svg>
  }, {
    name: 'Bank Transfer',
    svg: <div className="flex items-center gap-1.5 text-navy" data-id="element-239">
          <CreditCard className="w-4 h-4" data-id="element-240" />
          <span className="text-xs font-bold" data-id="element-241">ACH</span>
        </div>
  }];
  return <section className="py-16 md:py-20 bg-white border-y border-gray-100" data-id="element-242">
      <div className="container mx-auto px-4 md:px-6" data-id="element-243">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-244">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-soft text-blue font-semibold text-sm mb-4" data-id="element-245">
            <Lock className="w-3.5 h-3.5" data-id="element-246" />
            <span data-id="element-247">Secure Checkout</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-navy mb-3" data-id="element-248">
            Payment Methods We Accept
          </h2>
          <p className="text-muted" data-id="element-249">
            Flexible, secure payment options. Pay how you prefer — we've got you
            covered.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-wrap justify-center items-center gap-4 md:gap-6 max-w-4xl mx-auto" data-id="element-250">
          {methods.map((m, i) => <div key={i} title={m.name} className="bg-white border border-gray-200 rounded-lg px-5 py-3 h-14 flex items-center justify-center min-w-[100px] shadow-sm hover:shadow-md transition-shadow" data-id="element-251">
              {m.svg}
            </div>)}
        </motion.div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto mt-12 text-center" data-id="element-252">
          <div className="flex flex-col items-center" data-id="element-253">
            <div className="w-10 h-10 bg-gold-soft rounded-full flex items-center justify-center mb-3" data-id="element-254">
              <ShieldCheck className="w-5 h-5 text-navy" data-id="element-255" />
            </div>
            <div className="font-bold text-navy text-sm mb-1" data-id="element-256">
              256-bit SSL Encryption
            </div>
            <div className="text-xs text-muted" data-id="element-257">
              Bank-grade security on every transaction
            </div>
          </div>
          <div className="flex flex-col items-center" data-id="element-258">
            <div className="w-10 h-10 bg-gold-soft rounded-full flex items-center justify-center mb-3" data-id="element-259">
              <Lock className="w-5 h-5 text-navy" data-id="element-260" />
            </div>
            <div className="font-bold text-navy text-sm mb-1" data-id="element-261">
              PCI DSS Compliant
            </div>
            <div className="text-xs text-muted" data-id="element-262">
              We never store your card details
            </div>
          </div>
          <div className="flex flex-col items-center" data-id="element-263">
            <div className="w-10 h-10 bg-gold-soft rounded-full flex items-center justify-center mb-3" data-id="element-264">
              <CreditCard className="w-5 h-5 text-navy" data-id="element-265" />
            </div>
            <div className="font-bold text-navy text-sm mb-1" data-id="element-266">
              Cancel Anytime
            </div>
            <div className="text-xs text-muted" data-id="element-267">
              No contracts. Full refund within 7 days
            </div>
          </div>
        </div>
      </div>
    </section>;
}